import { makeAutoObservable } from "mobx";
import {
    deleteModule,
    getModuleById,
    saveOrUpdate,
    pagingModule,
    getAllModules
} from 'app/services/ModuleService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { Module } from "app/common/Model/Module";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ModuleStore {
    listAllModule = [];
    searchModule = new SearchObject();
    pageModule = null;
    selectedModule = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllModules = async () => {
        return await getAllModules()
            .then(({ data }) => {
                this.listAllModule = data || [];
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }
    pagingModule = async () => {
        return await pagingModule(this.searchModule)
            .then(({ data }) => {
                this.pageModule = data;
            })
            .catch((error) => {
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchModule) => {
        this.searchModule = { ...this.searchModule, ...searchModule };
        this.pagingModule();
    }

    handleOpenFormCreateOrEdit = async (moduleId) => {
        if (Boolean(moduleId)) {
            try {
                const { data } = await getModuleById(moduleId);
                this.selectedModule = data;
                this.openFormCreateOrEdit = true;
            } catch (error) {
                toast.error("Lấy dữ liệu có lỗi")
            }
        } else {
            this.selectedModule = new Module();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateModule = (module, { setSubmitting }) => {
        saveOrUpdate(module)
            .then(() => {
                this.selectedModule = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingModule();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (module) => {
        this.selectedModule = { id: module?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteModule(this.selectedModule?.id)
            .then(() => {
                if (this.searchModule?.pageIndex > 1 && this.pageModule?.content?.length === 1) {
                    this.searchModule.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingModule();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchModule = new SearchObject();
        this.pageModule = null;
        this.selectedModule = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    //for choosing module in ChooseModulePopup.jsx 
    listModule = [];
    moduleIdSet = null;

    isValidModule = module => {
        if (module && module?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addModule = module => {
        if (!this.isValidModule(module)) return;
        this.listModule.push(module);
        this.moduleIdSet.add(module?.id);
    }

    initializelistModule = modules => {
        this.moduleIdSet = new Set();
        this.listModule = [];
        if (modules && modules?.length > 0) {
            for (let i = 0; i < modules.length; i++) {
                this.addModule(modules[i]);
            }
        }
    }

    removeModule = module => {
        if (!this.isValidModule(module)) return;
        if (this.moduleIdSet.has(module?.id)) {
            this.moduleIdSet.delete(module?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = module => {
        if (!this.isValidModule(module)) return;
        return this.moduleIdSet.has(module?.id);
    }

    getModuleIdSet = () => {
        return this.moduleIdSet;
    }

    getListModule = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listModule && this.listModule?.length > 0) {
            for (let i = 0; i < this.listModule.length; i++) {
                const module = this.listModule[i];
                if (this.isExist(module) && !bufferIdSet.has(module?.id)) {
                    data.push(module);
                    bufferIdSet.add(module?.id);
                }
            }
        }
        this.listModule = data;
        return data;
    }

}
